// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-image[data-v-0625a5ec]{height:110px;max-width:155px}.lesson-card[data-v-0625a5ec]{width:155px}@media (min-width: 1024px){.main-image[data-v-0625a5ec]{height:144px;max-width:228px}.lesson-card[data-v-0625a5ec]{width:228px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
